import { portalAction, PortalThunk } from '../../'
import { GetCardScanSecretResponse, GetCardScanResultRequest, GetCardScanSecretRequest, VerifyScanResult } from '../../../model'

export const getCardScanIntentParam: PortalThunk<GetCardScanSecretRequest, GetCardScanSecretResponse> = portalAction('cardScan/create', async (data, thunk) => {
  return await thunk.extra.portalApi().post('/portal/consumers/card-scan/civ', data)
})

export const getCardScanResult: PortalThunk<GetCardScanResultRequest, VerifyScanResult> = portalAction('cardScan/finish', async (data, thunk) => {
  return await thunk.extra.portalApi().post('/portal/consumers/card-scan/check', data)
})
